/*
 * 2024-05-15 stripped down version that removes some of the "dynamic" components:
 *  * config must already exist (can't build a legend on the fly)
 *  * scale dependent changes removed
 *  * legend icons are always in a sprite, never individual
 */
/* eslint quotes:0, semi:0 */
/* global YAHOO */

import './treeview.js';

/**
 * @fileoverview  dLegend script creates a DHTML legend for a given json representation of the legend,
 * generated by make_dlegend_json.php.
 *
 * Multiple legends may exist on a page.
 *
 * @author brent.pellinen@dnr.state.mn.us
 * @author ken.boss@dnr.state.mn.us
 * @version 0.2
 * Based off of Yahoo! TaskNode example.
 *
 * RWG added misc stuff, search for 'RWG'
 *
 */

//Determine node behavior
var DLEGEND_CHECKSTYLE = "check";
var DLEGEND_RADIOSTYLE = "radio";

/**
 * @class dLegend class extends YAHOO.widget.TreeView class to create a DHTML legend.
 * @constructor
 * @requires YAHOO.js
 * @requires treeview.js
 * @requires dlegend.css
 *
 */
function dLegend() {
  this.initialize = function(elementId, config, callback_function) {
    this.init(elementId)
    // RWG
    this.iconurl = config['iconurl']
    this.imgtype = config['imgtype']
    this.sprite = config['sprite']
    this.onClickHandler = callback_function
    buildMenu(this, config);
    this.draw();

    // apply requested node collapsing
    if (typeof(config['collapsed_nodes']) != 'undefined') {
      for (var i = 0; i < config['collapsed_nodes'].length; i++) {
        this.collapse(config['collapsed_nodes'][i])
      }
    }

    // apply requested node checks
    if (typeof(config['checked_nodes']) != 'undefined') {
      for (let i = 0; i < config['checked_nodes'].length; i++) {
        this.check(config['checked_nodes'][i])
      }
    }
  }

  /**
   * @private
   */
  function buildMenu(self, config){

    for (var i = 0; i < config.data.length; i++) {

      var node = config.data[i]
      if (node.type == 'metagroup') {
        createMetagroup(node, self.getRoot())
      }
      // eventually could create group and layer nodes under legend root
      // level as well as metagroups, but the json-generating code would need
      // to be modified to handle that first.
    }

    function createMetagroup(node, parent) {

      var metagroup = new LegendMetagroup(parent, node);
      var layer;
      // var legendClass;
      var childnode, group, grandchildnode;

      for (let i=0; i<node.layers_and_groups.length; i++) {
        childnode = node.layers_and_groups[i]
        if (childnode.type == "metagroup") {
          createMetagroup(childnode, metagroup)
        } else if (childnode.type == "group") {
          group = new LegendLayer(metagroup, childnode);
          for (let j=0; j<childnode.layers.length; j++) {
            grandchildnode = childnode.layers[j];
            layer = new LegendLayer(group, grandchildnode);
            if (grandchildnode.classes) {
              for (let k=0; k<grandchildnode.classes.length; k++) {
                // legendClass = new LegendClass(layer, grandchildnode.classes[k]);
                new LegendClass(layer, grandchildnode.classes[k]);
              }
            }
          }
        } else if (childnode.type == "layer") {
          layer = new LegendLayer(metagroup, childnode);
          if (childnode.classes) {
            for (let j=0; j<childnode.classes.length; j++) {
              // legendClass = new LegendClass(layer, childnode.classes[j]);
              new LegendClass(layer, childnode.classes[j]);
            }
          }
        }
      }
    }
  }
}

dLegend.prototype = new YAHOO.widget.TreeView();

/**
 * Method to programmatically check or uncheck a node.
 *
 * @param  {string} is node id (metagroup, group, or layer name from mapfile).
 * @param  {boolean} status check layer where true/check and false/uncheck.
 */
dLegend.prototype.changeNodeStatus = function(id, status) {
  var n = this.getNodeById(id);
  if (!n) {
    console.error('unknown layer:', id);
  } else if ((n.noCheckbox == null || n.noCheckbox == false)) {
    if (status == null) {
      n.checked ? n.uncheck() : n.check()
    } else if (status == true) {
      n.check();
    } else if (status == false) {
      n.uncheck();
    }
  }
}

/**
 * Method to toggle a node's checkbox.
 *
 * @param  {string} id is node id (metagroup, group, or layer name from mapfile).
 */
dLegend.prototype.toggleCheck = function(id) {
  this.changeNodeStatus(id)
}

/**
 * Method to check a node's checkbox.
 *
 * @param  {string} id is node id (metagroup, group, or layer name from mapfile).
 */
dLegend.prototype.check = function(id) {
  this.changeNodeStatus(id, true)
}

/**
 * Method to uncheck a node's checkbox.
 *
 * @param  {string} id is node id (metagroup, group, or layer name from mapfile).
 */
dLegend.prototype.uncheck = function(id) {
  this.changeNodeStatus(id, false)
}

/**
 * Method to check all nodes.
 */
dLegend.prototype.checkAll = function() {
  for (var i=0; i<this.getRoot().children.length; i++) {
    this.getRoot().children[i].check()
  }
}

/**
 * Method to uncheck all nodes.
 */
dLegend.prototype.uncheckAll = function() {
  for (var i=0; i<this.getRoot().children.length; i++) {
    this.getRoot().children[i].uncheck()
  }
}

/**
 * Method to programatically expand or collapse a group tree.
 *
 * @param  {string} id is node id (metagroup, group, or layer name from mapfile).
 * @param {boolean} status expand layer where true/expand and false/collapse
 */
dLegend.prototype.changeNodeExpansion = function(id, status) {
  var n = this.getNodeById(id)
  if (n != null && n.hasChildren()) {
    if (status == null) {
      n.toggle()
    } else if (status == true) {
      n.expand()
    } else if (status == false) {
      n.collapse()
    }
  }
}

/**
 * Method to toggle a group's tree expansion.
 *
 * @param  {string} id is node id (metagroup, group, or layer name from mapfile).
 */
dLegend.prototype.toggleTree = function(id) {
  this.changeNodeExpansion(id)
}

/**
 * Method to expand a group tree.
 *
 * @param  {string} id is node id (metagroup, group, or layer name from mapfile).
 */
dLegend.prototype.expand = function(id) {
  this.changeNodeExpansion(id, true)
}

/**
 * Method to collapse a group tree.
 *
 * @param  {string} id is node id (metagroup, group, or layer name from mapfile).
 */
dLegend.prototype.collapse = function(id) {
  this.changeNodeExpansion(id, false)
}

/**
 * RWG Method returns an array of mapserver layers
 * May 06, 2012
 */
dLegend.prototype.getMapserverLayers = function() {
  var
    i, o, node,
    id = null,
    layers = [];
  for (i =1 ; ; i++) {
    node = this.getNodeByIndex(i);
    if (node === null) break;    // all done
    if (node.type === 'layer') { // each class of a mapserver layer is defined as a legend layer
      if (node.id !== id) {      // id is the mapserver layer name, repeated for each class
        id = node.id;            // found next mapserver layer
        o = {};                  // o = new Object;
        o[id] = node.checked;
        layers.push(o);
      }
    }
  }
  return layers;
}

/**
 * RWG method 2022-01-21
 * recursively expand each parent node above id
 */
dLegend.prototype.expandBranch = function(id) {
  if (id) { // when id is undefined we've reached the root of the legend tree
    let node = this.getNodeById(id)
    node.expand()
    this.expandBranch(node.parent.id)
  }
}

/**
 * RWG Method returns an array of layers that can be toggled in the layer control
 *
 * June, 2013
 */
dLegend.prototype.getToggleableLayers = function() {
  var i, node, layers = [];

  for (i =1 ; ; i++) {
    node = this.getNodeByIndex(i);
    if (node === null) break;    // all done
    if (! node.noCheckbox) {
      layers.push(node);
    }
  }
  return layers;
}

/**
 * @private
 */
dLegend.prototype.getNodeById = function(id) {
  // skip root node at index 0
  for (var i=1; i<this._nodes.length; i++) {
    var n = this._nodes[i];
    if (n.id == id) {
      return n;
    }
  }
  return null;
}

/**
 * @private
 */
function LegendNode(oData, oParent, expanded, checked) {

  if (oParent) {
    this.init(oData, oParent, expanded);
    this.setUpLabel(oData);
    this.checked = checked;
    if (checked)  this.check();
  }
}

/**
 * @private
 */
function LegendMetagroup(parent, child) {
  var optionStyle = child.element;
  if (!optionStyle) optionStyle = DLEGEND_CHECKSTYLE; // defaults to check box if none specified
  var label = child.label;
  // RWG: label += (optionStyle == DLEGEND_CHECKSTYLE ? "" : " (Select One)");
  this.type = child.type
  this.id = child.id;
  this.optionStyle = optionStyle;
  // RWG 8/20/2011 for Rock Springs
  // this.noCheckbox = (optionStyle == DLEGEND_RADIOSTYLE) ? true : false
  this.noCheckbox = true ;

  // init all metagroups as expanded, to allow styling of child elements
  // selective collapsing is applied in dLegend::initialize()
  this.init(label, parent, true);
  this.setUpLabel(label);
}

/**
 * @private
 */
function LegendLayer(parent, child) {
  this.type = child.type
  this.id = child.id;
  this.icon_class = child.icon_class;
  if (child.minscaledenom) this.minscaledenom = child.minscaledenom;
  if (child.maxscaledenom) this.maxscaledenom = child.maxscaledenom;
  this.icon_class = child.icon_class;
  this.noCheckbox = (child.type == 'class' || parent.type == 'group');
  // init all layers having children as expanded, to allow styling of child elements
  // (but don't expand layers w/no children, or empty child divs show up as blank space in IE)
  // selective collapsing is applied in dLegend::initialize()
  var expanded = (child.type == 'group' || (child.type == 'layer' && child.classes))
  this.init(child.label, parent, expanded);
  this.setUpLabel(child.label);
}

/**
 * @private
 */
function LegendClass(parent, child) {
  this.type = child.type
  this.noCheckbox = true;
  this.icon_class = child.icon_class;
  if (child.minscaledenom) this.minscaledenom = child.minscaledenom;
  if (child.maxscaledenom) this.maxscaledenom = child.maxscaledenom;
  // init all classes as collapsed, or empty child divs show up as blank space in IE
  this.init(child.label, parent, false);
  this.setUpLabel(child.label);
}

/**
 * @private
 */
LegendNode.prototype = new YAHOO.widget.TextNode();

LegendNode.prototype.noCheckbox = false;
/**
 * checkState
 * 0=unchecked, * 1=some children checked, 2=all children checked, 3=unchecked and layer out of scale (ghosted), 4=checked but layer out of scale
 *
 * @private
 * @type int
 */
LegendNode.prototype.checkState = 0;

/**
 * True if checkstate is 1 (some children checked) or 2 (all children checked) or 4 (checked but layer is out of scale),
 * false if 0 (unchecked) or 3 (unchecked and out of scale).
 *
 * @private
 * @type boolean
 */
LegendNode.prototype.checked = false;

/**
 * @private
 */
LegendMetagroup.prototype = new LegendNode();
LegendMetagroup.prototype.className = "LegendMetagroup";

/**
 * @private
 */
LegendLayer.prototype = new LegendNode();
LegendLayer.prototype.minscaledenom = 0;
LegendLayer.prototype.maxscaledenom = 0;
LegendLayer.prototype.className = "LegendLayer";

/**
 * Check the type of node, radio or checkbox
 * @private
 */
LegendLayer.prototype.getRootOptionStyle = function() {
  var p = this.parent;
  if (p && p.getRootOptionStyle) return p.getRootOptionStyle();
  if (p && p.optionStyle) {
    return p.optionStyle;
  }
  if (this.optionStyle) {
    return this.optionStyle;
  }
};

/**
 * @private
 */
LegendClass.prototype = new LegendNode();
LegendClass.prototype.className = "LegendClass";

/**
 * The id of the check element
 *
 * @private
 * @type string
 */
LegendNode.prototype.getCheckElId = function() {
  return "ygtvcheck" + this.index;
};
/**
 * The id of the radio element
 *
 * @private
 * @type string
 */
LegendNode.prototype.getRadioElId = function() {
  return "ygtvcheck" + this.index;
};
/**
 * The id of the legend icon image
 *
 * @private
 * @type string
 */
LegendNode.prototype.getLegendIconImgId = function() {
  return "legend_icon" + this.index;
};
/**
 * Returns the check box element
 *
 * @private
 * @return the check html element (img)
 */
LegendNode.prototype.getCheckEl = function() {
  return document.getElementById(this.getCheckElId());
};
/**
 * Returns the radio box element
 *
 * @private
 * @return the radio html element (img)
 */
LegendNode.prototype.getRadioEl = function() {
  return document.getElementById(this.getRadioElId());
};
/**
 * Returns the legend icon image
 *
 * @private
 * @type string
 */
LegendNode.prototype.getLegendIconImg = function() {
  return document.getElementById(this.getLegendIconImgId());
};
/**
 * The style of the check element, derived from its current state
 *
 * @private
 * @return {string} the css style for the current check state
 */
LegendNode.prototype.getCheckStyle = function() {
  return "ygtvcheck" + this.checkState;
};
/**
 * The style of the radio element, derived from its current state
 *
 * @private
 * @return {string} the css style for the current check state
 */
LegendNode.prototype.getRadioStyle = function() {
  return "ygtvcheck" + this.checkState;
};

/**
 * Returns the link that will invoke this node's check toggle
 *
 * @private
 * @return {string} returns the link required to adjust the checkbox state
 */
LegendNode.prototype.getCheckLink = function() {
  return "YAHOO.widget.TreeView.getNode('" + this.tree.id + "'," +
         this.index + ").checkClick(); ";
};

/**
 * Returns the link that will invoke this node's radio toggle
 *
 * @private
 * @return {string} returns the link required to adjust the checkbox state
 */
LegendNode.prototype.getRadioLink = function() {
  return "YAHOO.widget.TreeView.getNode('" + this.tree.id + "'," +
         this.index + ").radioClick()";
};

// Overrides YAHOO.widget.TextNode
LegendNode.prototype.getNodeHtml = function() {

  var sb = new Array();

  sb[sb.length] = '<table border="0" cellpadding="0" cellspacing="0">';
  sb[sb.length] = '<tr>';

  for (var i = 0; i < this.depth; ++i) {
    sb[sb.length] = '<td class="' + this.getDepthStyle(i) + '">&nbsp;</td>';
  }

  sb[sb.length] = '<td';
  sb[sb.length] = ' id="' + this.getToggleElId() + '"';
  sb[sb.length] = ' class="' + this.getStyle() + '"';
  if (this.hasChildren(true)) {
    sb[sb.length] = ' onmouseover="this.className=';
    sb[sb.length] = 'YAHOO.widget.TreeView.getNode(\'';
    sb[sb.length] = this.tree.id + '\',' + this.index + ').getHoverStyle()"';
    sb[sb.length] = ' onmouseout="this.className=';
    sb[sb.length] = 'YAHOO.widget.TreeView.getNode(\'';
    sb[sb.length] = this.tree.id + '\',' + this.index + ').getStyle()"';
  }
  sb[sb.length] = ' onclick="javascript:' + this.getToggleLink() + '">&nbsp;';
  sb[sb.length] = '</td>';


  // check box
  var buttonStyle = 'none';
  if ((this.optionStyle && this.optionStyle == DLEGEND_CHECKSTYLE) ||
      (this.getRootOptionStyle && this.getRootOptionStyle() == DLEGEND_CHECKSTYLE)) {
    if (!this.noCheckbox) {
      buttonStyle = 'check';
      sb[sb.length] = '<td';
      sb[sb.length] = ' id="' + this.getCheckElId() + '"';
      sb[sb.length] = ' class="' + this.getCheckStyle() + '"';
      sb[sb.length] = ' onclick="javascript:' + this.getCheckLink() + '">';
      sb[sb.length] = '&nbsp;</td>';
    } else {
      sb[sb.length] = '<td';
      sb[sb.length] = ' id="' + this.getCheckElId() + '"';
      // RWG 8/20/2011 for Rock Springs remove &nbsp;
      // sb[sb.length] = ' >&nbsp;</td>';
      sb[sb.length] = ' ></td>';
    }
  } else {
    //radio button
    if (!this.noCheckbox) {
      buttonStyle = 'radio';
      sb[sb.length] = '<td';
      sb[sb.length] = ' id="' + this.getRadioElId() + '"';
      sb[sb.length] = ' class="' + this.getRadioStyle() + '"';
      sb[sb.length] = ' onclick="javascript:' + this.getRadioLink() + '">';
      sb[sb.length] = '&nbsp;</td>';
    }
  }


  sb[sb.length] = '<td>';
  sb[sb.length] = '<a';
  sb[sb.length] = ' id="' + this.labelElId + '"';
  sb[sb.length] = ' class="' + this.labelStyle + '"';
  if (buttonStyle == 'check') {
    sb[sb.length] = ' href="javascript:' + this.getCheckLink() + '"';
  } else if (buttonStyle == 'radio') {
    sb[sb.length] = ' href="javascript:' + this.getRadioLink() + '"';
  } else {
    sb[sb.length] = ' href="' + this.href + '"';
  }
  sb[sb.length] = ' target="' + this.target + '"';
  if (this.hasChildren(true)) {
    sb[sb.length] = ' onmouseover="document.getElementById(\'';
    sb[sb.length] = this.getToggleElId() + '\').className=';
    sb[sb.length] = 'YAHOO.widget.TreeView.getNode(\'';
    sb[sb.length] = this.tree.id + '\',' + this.index + ').getHoverStyle()"';
    sb[sb.length] = ' onmouseout="document.getElementById(\'';
    sb[sb.length] = this.getToggleElId() + '\').className=';
    sb[sb.length] = 'YAHOO.widget.TreeView.getNode(\'';
    sb[sb.length] = this.tree.id + '\',' + this.index + ').getStyle()"';
  }
  sb[sb.length] = ' >';
  sb[sb.length] = this.getLegendIconImgTag() + this.label;
  sb[sb.length] = '</a>';
  sb[sb.length] = '</td>';
  sb[sb.length] = '</tr>';
  sb[sb.length] = '</table>';
  return sb.join("");

};

/**
 * Refresh the state of this check node's parent, if the parent is a metagroup node.
 * Determines whether to display metagroup checkbox as
 *   empty (no layers on), minus sign (some layers on), or checked (all layers on).
 *
 * @private
 */
LegendNode.prototype.updateMetagroup = function() {
  if (!this.parent || this.parent.className != 'LegendMetagroup') {
    return;
  }
  var node = this.parent;
  var somethingChecked = false;
  var somethingNotChecked = false;

  for (var i = 0; i < node.children.length; ++i) {
    if (node.children[i].checked) {
      somethingChecked = true;
      // checkState will be 1 if the child node is metagroup and has unchecked children
      if (node.children[i].checkState == 1) {
        somethingNotChecked = true;
      }
    } else {
      somethingNotChecked = true;
    }
  }
  if (somethingChecked) {
    node.setCheckState((somethingNotChecked) ? 1 : 2);
  } else {
    node.setCheckState(0);
  }
  // node.updateStyling();
  node.updateMetagroup();
};

/**
 * Update check node styling to reflect the current
 * state of the node.
 * @private
 */
LegendNode.prototype.updateStyling = function() {
  if (!this.noCheckbox) {
    this.getCheckEl().className = this.getCheckStyle();
    this.performCallback();
  }
};

LegendNode.prototype.performCallback = function() {
  if (this.className == 'LegendLayer' && this.tree.onClickHandler && this.checkState != 1) {
    this.tree.onClickHandler(this.id, (this.checkState == 2 || this.checkState == 4) ? true:false);
  }
};

LegendNode.prototype.getLegendIconImgTag = function() {
  let tag = ''
  // "blank" below is a substitute for src= "blank.gif" which makes a network request
  const blank = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  if (this.icon_class) {
    let icon = this.icon_class.replace(',', '')
    tag = `<img class="keyimg ${icon}" src="${blank}"/>&nbsp;`
  }
  return tag
}

/**
 * Updates the state.  The checked property is true if the state is 1 or 2 or 4
 *
 * @private
 * @param the new check state
 */
LegendNode.prototype.setCheckState = function(state) {
  this.checkState = state;
  this.checked = (state > 0 && state != 3);
  this.outOfScale = (state == 3 || state == 4) ? true : false;
  this.updateStyling();
};

/** rwg
  use this to push history by adding a clickEnd() function to the legend instance
 */
LegendNode.prototype.clickEnd= function(type) {
  // console.log('this.tree', this.tree)
  if (typeof this.tree.clickEnd === 'function') {
    this.tree.clickEnd(type);
  }
}

/**
 * Invoked when the user clicks the check box
 * @private
 */
LegendNode.prototype.checkClick = function() {
  (this.checked == true) ? this.uncheck() : this.check()
  this.clickEnd('check');
};

/**
 * Check this node
 */
LegendNode.prototype.check = function() {
  if (this.checkState == 0 || this.checkState == 1) {
    this.setCheckState(2);
  } else if (this.checkState == 3) {
    this.setCheckState(4);
  }
  for (var i = 0; i < this.children.length; ++i) {
    this.children[i].check();
  }
  this.updateMetagroup();
};

/**
 * Uncheck this node
 */
LegendNode.prototype.uncheck = function() {
  if (this.checkState == 1 || this.checkState == 2) {
    this.setCheckState(0);
  } else if (this.checkState == 4) {
    this.setCheckState(3);
  }
  for (var i = 0; i < this.children.length; ++i) {
    this.children[i].uncheck();
  }
  this.updateMetagroup();
};

/**
 * Invoked when the user clicks the radio box
 * @private
 */
LegendNode.prototype.radioClick = function() {
  (this.checked == true) ? this.uncheck() : this.radioSelect()
  this.clickEnd('radio');
};

LegendNode.prototype.radioSelect = function() {
  for (var i=0; i<this.getSiblings().length; i++) {
    this.getSiblings()[i].uncheck()
  }
  this.check()
};


export {dLegend};
